"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var GridFilterDetailTemplateComponent_1 = __importDefault(require("./GridFilterDetailTemplateComponent"));
var helpers_1 = require("./helpers");
// @ts-ignore
var query_string_1 = __importDefault(require("query-string"));
var react_router_dom_1 = require("react-router-dom");
var GridFilterDetailTemplateContainer = function (_a) {
    var clearFilter = _a.clearFilter, children = _a.children;
    var replace = (0, react_router_dom_1.useHistory)().replace;
    var location = (0, react_router_dom_1.useLocation)();
    var withDetailFilter = query_string_1["default"].parse(location.search).withDetailFilter === '1';
    var showDetailFilter = function () { return (0, helpers_1.toggleDetailFilter)('1')(replace, location); };
    var hideDetailFilter = function () { return (0, helpers_1.toggleDetailFilter)('0')(replace, location); };
    return (react_1["default"].createElement(GridFilterDetailTemplateComponent_1["default"], { withDetailFilter: withDetailFilter, clearFilter: clearFilter, hideDetailFilter: hideDetailFilter, showDetailFilter: showDetailFilter }, children));
};
exports["default"] = GridFilterDetailTemplateContainer;
